import { createSelector } from 'reselect';

import { selectLoanApplication } from './loanApplication.selectors';

const selectNonUSLocations = createSelector(
  selectLoanApplication,
  ({ nonUSLocations }) => nonUSLocations,
);

export const selectIsNonUSLocationsExist = createSelector(
  selectNonUSLocations,
  nonUSLocations => !!nonUSLocations.length,
);

export const selectNonUSLocationOptions = createSelector(selectNonUSLocations, locations =>
  locations.map(name => ({ name, value: name })).sort((a, b) => a.name.localeCompare(b.name)),
);
